import { render } from "./BlueCatIcon.svg?vue&type=template&id=5bf3ed2e"
const script = {}
script.render = render

export default script